import { Col, Button, ButtonGroup } from "react-bootstrap";
import { FILTERS } from "./constants/filters";

const Filters = ({ changeFilter, filters, showChasseAuxSaveurs }) => {
    return (
        <Col className="mapbtn">
            <ButtonGroup className="GroupBtn">
                <Button
                    onClick={() => changeFilter(FILTERS.ESPACES)}
                    variant={filters === FILTERS.ESPACES ? "dark" : "outline-dark"}
                >
                    <span>Espaces</span>
                </Button>
                <Button
                    onClick={() => changeFilter(FILTERS.ECO_CONCEPTION)}
                    variant={filters === FILTERS.ECO_CONCEPTION ? "dark" : "outline-dark"}
                >
                    <span>Eco-Conception</span>
                </Button>
                {showChasseAuxSaveurs && (
                    <Button
                        onClick={() => changeFilter(FILTERS.CHASSE_AUX_SAVEURS)}
                        variant={filters === FILTERS.CHASSE_AUX_SAVEURS ? "dark" : "outline-dark"}
                    >
                        <span>Chasse aux saveurs</span>
                    </Button>
                )}
            </ButtonGroup>
        </Col>
    )
}

export default Filters;
